import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import Global from '../../../../../store/global-selectors';
import { messages } from './messages';

export const StoreDropdown = ({ onChange, selectedStoreId = '' }) => {
  const stores = useSelector(Global.selectSellerStores) || [];
  const intl = useIntl();
  const selectedStore = stores.find((store) => store.storeGuid === selectedStoreId);
  const text = selectedStore ? selectedStore.name : intl.formatMessage(messages.anyStore);
  return (
    <DropdownMenu dropdownMenuShouldHaveWidthOfButton fullWidth variant='form'>
      <DropdownMenuToggler text={text}>{text}</DropdownMenuToggler>
      {stores.map((store) => (
        <DropdownMenuItem key={store.storeGuid} onClick={() => onChange(store.storeGuid)}>
          {store.name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

StoreDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedStoreId: PropTypes.string,
};
